import FileUpload from './FileUpload';
import VideoBox from './video/VideoBox';

export default function Editor() {
  return (
    <div className="flex h-[23rem] w-full gap-2 overflow-y-scroll">
      <VideoBox />
      <FileUpload />
    </div>
  );
}
